import { TimeOffType } from '@sdk/timeOffs/types/TimeOffType';

const getUnpaidTimeOffTypes = (timeOffTypes: TimeOffType[]): TimeOffType[] => {
  return timeOffTypes.filter((type) => !type.paid);
};

export default getUnpaidTimeOffTypes;
